//Hooks
import { useCheckPermission } from './../../Auth/hooks/useCheckPermission';
import { useLocation } from 'react-router-dom';
//Constants
import { Resources, Scopes } from '../../Auth/model/auth.model';
import { AppRoutes } from './../../Routes/App.routes';
//Types
import { ISidebarLink } from 'spark-component-library';
//Icons
import { HiOutlineDocumentReport as StatementsIcon } from 'react-icons/hi';

const useSidebarLinks = () => {
  const { pathname } = useLocation();

  let sidebarLinks: ISidebarLink[] = [
    {
      name: 'Statements',
      id: AppRoutes.STATEMENTS,
      icon: <StatementsIcon size={'24px'} />,
      display: useCheckPermission(Resources.Statements, Scopes.Read) /* && !statementsDisabled*/,
      selected: pathname.includes(AppRoutes.STATEMENTS),
      category: 'Reports',
    },
  ];

  return sidebarLinks;
};
export default useSidebarLinks;
